import React from 'react';
import { Icon } from './Icon.js';
export const IconAlignVerticalFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M16.25,9.75H1.75c-.414,0-.75-.336-.75-.75s.336-.75,.75-.75h14.5c.414,0,.75,.336,.75,.75s-.336,.75-.75,.75Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("rect", { x: "3", y: "3", width: "5", height: "12", rx: "1.75", ry: "1.75", fill: "currentColor" }),
        React.createElement("rect", { x: "10", y: "5", width: "5", height: "8", rx: "1.75", ry: "1.75", fill: "currentColor" })));
};
//# sourceMappingURL=IconAlignVerticalFill18.js.map